import links from '@/assets/json/footer.json';

export default function useI18nMeta() {
  /********************
   * COMPOSITIONS      *
   ********************/
  const localePath = useLocalePath();
  const router = useRouter();
  const { $gettext, interpolate, $pgettext } = useGettext();
  const { locale } = useI18n();

  /********************
   * REFS & VARS       *
   ********************/
  const i18nTermsOfUseLink = computed(() => {
    const text = $pgettext('Terms of Use Link Text', 'terms of use from 01.07.2019');
    const link = router.resolve(
      localePath({
        name: 'info-all',
        params: {
          all: links.termsOfUse[locale.value] || links.termsOfUse.en || links.termsOfUse.de || null,
        },
      }),
    );
    return `<a href="${link.href}" target="_blank" rel="noopener">${text}</a>`;
  });

  const i18nPoliciesLink = computed(() => {
    const text = $pgettext('Upload Policies Link Text', 'upload policies');
    return `<a href="#policies" target="_blank" rel="noopener">${text}</a>`;
  });

  const i18AcceptTermsCheckboxText = computed(() => {
    const translated = $gettext(
      'By posting or uploading content, I acknowledge the %{termslink} and grant Camping.info a royalty-free, non-exclusive, pertaining, spatially and temporally unrestricted right to use, reproduce, edit, distribute, transmit and make publicly accessible the content for operating and advertising the services in all media.',
    );
    return interpolate(translated, { termslink: i18nTermsOfUseLink.value }, true);
  });

  const i18nMarketingSignupLabel = $gettext('Yes, I’d like to receive personal offers, cool giveaways, and the latest camping news right in my inbox. Real tips you actually want to check out.');

  return {
    i18AcceptTermsCheckboxText,
    i18nMarketingSignupLabel,
    i18nPoliciesLink,
    i18nTermsOfUseLink,
  };
}
